import React, {useContext, useState,useEffect} from 'react';
import {ShippingInstructionContext} from "./shipping-instruction-context";
import _ from 'underscore';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";

function StatementSection(props) {
    const {data, setData, statements} = useContext(ShippingInstructionContext);
    const [open, setOpen] = useState(false);
    const [list, setList] = useState([]);
    const [dirty, setDirty] = useState(false);

 
     useEffect(() => {
        if(dirty){
            props.checkIfDirty(dirty);
        }
    },[dirty]);

    const refreshStatementList = () => {
        const setIds = data.sectionStatements.map(s => s.statementId);
        const theList = statements
            .filter(s => s.sectionId === props.section.id)
            .filter(s => !_.contains(setIds, s.id));
        if (theList.length > 0) {
            setList(theList);
        } else {
            setList([])
        }

    }

    const onStatementAdd = ss => {
        setDirty(true);
        var statements = data.sectionStatements.slice();
        statements.push({
            statementId: ss.id,
            sectionId: props.section.id,
            statementOrder: 1,
            statementName: ss.title,
            statements: ss.allContent
        });
        setData({...data, sectionStatements: statements});
        handleClose();
    }

    const removeRow = (row) => {
        setDirty(true);
        const statements = data.sectionStatements.slice().filter(d => d.statementId !== row.statementId);
        setData({...data, sectionStatements: statements});
        refreshStatementList();
    };

    const handleClose = () => {
        setOpen(false);
    }

    const handleOpen = () => {
        refreshStatementList();
        setOpen(true);
    }

    React.useEffect(() => {
        refreshStatementList();
        // eslint-disable-next-line
    }, [statements]);

    return (
        <Grid>
            <Grid item xs={12}>


                {
                    (list.length > 0 && (!props.section.countryDefaultSection || data.overrideCountryDefaults)) &&
                    <Button color="primary" href="" onClick={() => handleOpen()}>Add Statement</Button>
                }
                {
                    data.sectionStatements.filter(s => (s.sectionId === props.section.id)).length > 0 &&
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Statements</TableCell>
                                    <TableCell>&nbsp;</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.sectionStatements.filter(s => (s.sectionId === props.section.id)).map((row, rowIndex) => (
                                    <>
                                        <TableRow key={'statement-row-' + rowIndex} className={row.fromCountryDefault ? 'ql-bg-blue' : ''}>
                                            <TableCell colSpan={2} style={{padding: 0, paddingLeft: 10, margin: 0}}
                                                       component="td"
                                                       scope="row">
                                                Statement: <b>{row.statementName}</b>
                                            </TableCell>
                                            <TableCell style={{padding: 0, margin: 0}}>
                                                {
                                                    (!props.section.countryDefaultSection || data.overrideCountryDefaults) &&
                                                    <IconButton size="small" aria-label="delete"
                                                                onClick={() => removeRow(row)}>
                                                        <DeleteIcon color="error"/>
                                                    </IconButton>
                                                }
                                            </TableCell>
                                        </TableRow>
                                        {row.statements.map((member, index) => (
                                            <TableRow key={row.id + '-member-' + index}>
                                                <TableCell style={{padding: 10, paddingLeft: 50, margin: 0}}
                                                           component="td"
                                                           scope="row">
                                                </TableCell>
                                                <TableCell style={{padding: 0, margin: 0, paddingLeft: 5}}>
                                                    <div
                                                        dangerouslySetInnerHTML={{__html: member}}></div>
                                                </TableCell>
                                            </TableRow>))
                                        }
                                    </>
                                ))
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>
                }
            </Grid>
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Add statement set</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Please add the statement set here.
                    </DialogContentText>

                    {list.length > 0 &&
                        <TableContainer component={Paper}>
                            <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Statement</TableCell>
                                        <TableCell>&nbsp;</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        list.map((row) => (
                                            <>
                                                <TableRow key={row.id}>
                                                    <TableCell style={{padding: 10, paddingLeft: 10, margin: 0}}
                                                               component="td"
                                                               scope="row">
                                                        {row.title}

                                                    </TableCell>
                                                    <TableCell style={{padding: 0, margin: 0, paddingLeft: 5}}>
                                                        <Button onClick={() => onStatementAdd(row)}>Add</Button>
                                                    </TableCell>
                                                </TableRow>
                                            </>))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    }
                    {
                        list.length === 0 &&
                        <>There is no statement set that can be added to this shipping instruction.</>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </Grid>
    );
}

export default StatementSection;